/**
 * Common Media Client Data Object Type
 *
 * @group CMCD
 *
 * @beta
 */
export var CmcdObjectType;
(function (CmcdObjectType) {
    /**
     * text file, such as a manifest or playlist
     */
    CmcdObjectType["MANIFEST"] = "m";
    /**
     * audio only
     */
    CmcdObjectType["AUDIO"] = "a";
    /**
     * video only
     */
    CmcdObjectType["VIDEO"] = "v";
    /**
     * muxed audio and video
     */
    CmcdObjectType["MUXED"] = "av";
    /**
     * init segment
     */
    CmcdObjectType["INIT"] = "i";
    /**
     * caption or subtitle
     */
    CmcdObjectType["CAPTION"] = "c";
    /**
     * ISOBMFF timed text track
     */
    CmcdObjectType["TIMED_TEXT"] = "tt";
    /**
     * cryptographic key, license or certificate.
     */
    CmcdObjectType["KEY"] = "k";
    /**
     * other
     */
    CmcdObjectType["OTHER"] = "o";
})(CmcdObjectType || (CmcdObjectType = {}));
//# sourceMappingURL=CmcdObjectType.js.map